import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import { Search } from "lucide-react";
import routes from "../routes/SearchIndex";
import {
  generateSearchIndex,
  searchContent,
  highlightSearchTerm,
} from "../utils/SearchUtils";
import { useSearchContext } from "../context/SearchContext";

export default function SearchBar() {
  const { searchTerm, setSearchTerm, setResults } = useSearchContext();
  const navigate = useNavigate();

  const [searchIndex, setSearchIndex] = React.useState([]);

  useEffect(() => {
    setSearchIndex(generateSearchIndex(routes));
  }, []);

  const performSearch = useCallback(() => {
    if (!searchTerm.trim() || !Array.isArray(searchIndex)) return;

    const searchResults = searchContent(searchTerm, searchIndex).map(
      (item) => ({
        route: item.path,
        title: item.title,
        preview: highlightSearchTerm(item.content, searchTerm),
      })
    );

    setResults(searchResults);
    navigate("/Busqueda-Resultado");
  }, [searchTerm, searchIndex, setResults, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    performSearch();
  };

  const handleIconClick = () => {
    performSearch();
  };

  return (
    <form onSubmit={handleSubmit} className="form-search">
      <label htmlFor="header-search" className="form-label sr-only">
        Buscar en IDECABA
      </label>
      <div className="search-container">
        <input
          type="search"
          className="form-control input-search input-search-with-button"
          id="header-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Buscar en IDECABA"
          aria-label="Buscar en IDECABA"
        />
        <button className="button-search" type="submit" aria-label="Buscar">
          <Search className="w-4 h-4 d-none" />
        </button>
      </div>
    </form>
  );
}
